export type TWidgetType = 'BUTTON' | 'MAP';

export interface ICropping {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface ImageVariant {
  id: string;
  type: string;
  attribution: string;
  path: string;
  url: string;
  name?: string;
  width?: number;
  height?: number;
  size?: number;
  isOffensive?: boolean;
  imageId: string;
  labels: string[];
  createdTimestamp?: string;
  crop?: ICropping;
}

/**
 * @deprecated
 */
export interface ImageType {
  attribution: string;
  url: string;
  crop: ICropping;
  cropUrl: string;
}

export enum EVideoUploadStatus {
  INITIATED = 'INITIATED',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export type TVideoUploadStatus = `${EVideoUploadStatus}`;

export interface IVideo {
  id: string;
  fileName: string;
  fileSize: number;
  publicUrl: string;
  createdTimestamp: Date;
  uploadStatus: TVideoUploadStatus;
}

export interface IColorType {
  hexCode: string;
}

export type TMediaType = ImageType | ImageVariant | IVideo | IColorType;

/**
 * @deprecated
 */
export interface IMediaItem {
  imageId: string | null;
  imageVariantId: string | null;
  videoId: string | null;
  crop: ICropping | null;
  url: string | null;
}
